import Navbar from "./Components/Navbar"
import Hero from "./Components/Hero"
import About from "./Components/About"
import Portfolio from "./Components/Portfolio"
import Contact from "./Components/Contact"
import Footer from "./Components/Footer"
export default function App(){
    return(
       <>
       <Navbar/>
       <Hero/>
       <About/>
       <Portfolio/>
       <Contact/>
       <Footer/>
       </>
    )
}